/**
 * 시그니처 1: 결측 해칭 (DESIGN §8.6).
 *
 * 결측을 0 으로 그리지 않는다 (CLAUDE.md 절대원칙 2). "값이 0" 과 "모른다" 가
 * 같아 보이면 읽는 사람은 반드시 오독한다.
 */

import './MissingHatch.css'

export function MissingLegend() {
  return (
    <span className="misslegend">
      <span className="misslegend__swatch hatch-missing" aria-hidden="true" />
      결측(관측 없음)
    </span>
  )
}

interface BandProps {
  /** 결측 구간 [0..1] 비율 목록 — 차트 위에 겹쳐 그린다 */
  bands: { startRatio: number; endRatio: number; label: string }[]
}

export function MissingBands({ bands }: BandProps) {
  if (bands.length === 0) return null
  return (
    <div className="missbands" aria-hidden="true">
      {bands.map((b) => (
        <div
          key={`${b.startRatio}-${b.endRatio}`}
          className="missbands__band hatch-missing"
          style={{
            left: `${b.startRatio * 100}%`,
            width: `${Math.max(0.4, (b.endRatio - b.startRatio) * 100)}%`,
          }}
          title={b.label}
        />
      ))}
    </div>
  )
}

/** 결측 일자를 목록으로도 남긴다 — 그래픽을 못 보는 사용자를 위해 */
export function MissingDates({ dates }: { dates: string[] }) {
  if (dates.length === 0) return null
  return (
    <details className="missdates">
      <summary>
        결측 일자 <span className="num">{dates.length}</span>일 (0 으로 채우지 않았습니다)
      </summary>
      <p className="missdates__list num">{dates.join(', ')}</p>
    </details>
  )
}
